
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["financeCenter_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M959.359 854.226c0 12.485-2.133 24.14-6.404 34.98-4.271 10.84-10.347 20.364-18.227 28.577-7.884 8.214-17.085 14.618-27.595 19.213-10.506 4.6-22.004 6.898-34.488 6.898h-715.38c-12.48 0-24.306-2.298-35.475-6.898-11.164-4.595-21.017-10.999-29.558-19.213-8.543-8.214-15.276-17.738-20.2-28.576-4.93-10.84-7.391-22.497-7.391-34.981V362.523c0-24.96 8.701-46.145 26.11-63.554 17.409-17.408 38.595-26.115 63.559-26.115h715.38c24.964 0 46.15 8.707 63.559 26.115 17.409 17.41 26.11 38.595 26.11 63.554v134.014H735.681c-24.965 0-46.15 8.538-63.56 25.617-17.408 17.08-26.11 38.101-26.11 63.065.66 17.08 4.272 32.19 10.841 45.328 5.253 11.17 13.96 21.35 26.11 30.545 12.155 9.196 29.729 13.796 52.719 13.796h223.678v179.338zm-134.01-626.7H377.99c35.474-18.39 68.976-36.127 100.507-53.206a9304.123 9304.123 0 0081.79-43.36c26.932-14.448 47.954-25.617 63.064-33.502 22.99-12.48 43.519-18.23 61.586-17.244 18.062.986 33.337 4.106 45.816 9.36 14.454 7.226 26.937 16.75 37.449 28.577l57.148 109.376zM691.34 585.22c0-12.48 4.27-22.99 12.808-31.533 8.544-8.538 19.054-12.808 31.534-12.808 12.479 0 22.99 4.27 31.533 12.808 8.538 8.542 12.808 19.054 12.808 31.533s-4.27 23.155-12.808 32.026c-8.544 8.865-19.054 13.302-31.533 13.302-12.48 0-22.99-4.436-31.534-13.302-8.538-8.871-12.808-19.546-12.808-32.026zm0 0"}})])
          )
        }
      }
    